/** 
  All of the routes for the Ajce Hostel App React are added here,
  You can add a new route, customize the routes and delete the routes here.

  Once you add a new route on this file it will be visible automatically on
  the Sidenav.

  For adding a new route you can follow the existing routes in the routes array.
  1. The `type` key with the `collapse` value is used for a route.
  2. The `type` key with the `title` value is used for a title inside the Sidenav. 
  3. The `type` key with the `divider` value is used for a divider between Sidenav items.
  4. The `name` key is used for the name of the route on the Sidenav.
  5. The `key` key is used for the key of the route (It will help you with the key prop inside a loop).
  6. The `icon` key is used for the icon of the route on the Sidenav, you have to add a node.
  7. The `collapse` key is used for making a collapsible item on the Sidenav that has other routes
  inside (nested routes), you need to pass the nested routes inside an array as a value for the `collapse` key.
  8. The `route` key is used to store the route location which is used for the react router.
  9. The `href` key is used to store the external links location.
  10. The `title` key is only for the item with the type of `title` and its used for the title text on the Sidenav.
  10. The `component` key is used to store the component of its route.
*/

// Ajce Hostel App React layouts
import Dashboard from "layouts/dashboard";
import SignIn from "layouts/authentication/sign-in";
import SignUp from "layouts/authentication/sign-up";
import AddStudents from "layouts/addStudents";
import StudentProfile from "layouts/studentProfile";
import StudentsList from "layouts/studentsList";
import AdvancedSearch from "layouts/advanceSearch";
import StudentInOut from "layouts/studentInOut";
import ResetPassword from "layouts/authentication/reset-password";
import Stdatt from "layouts/studentAttendance";
import EditStudents from "layouts/editStudents";

// @mui icons
import Icon from "@mui/material/Icon";
import QuerySearch from "layouts/querySearch";

const routes = [
  {
    type: "title",
    title: "general",
    key: "general",
  },
  {
    type: "collapse",
    name: "Dashboard",
    key: "dashboard",
    icon: <Icon fontSize="small">dashboard</Icon>,
    route: "/dashboard",
    component: <Dashboard />,
  },

  {
    type: "title",
    title: "Manage Students",
    key: "manage-students",
  },
  {
    type: "collapse",
    name: "Add Students",
    key: "students/add",
    icon: <Icon fontSize="small">add</Icon>,
    route: "/students/add",
    component: <AddStudents />,
  },
  {
    type: "",
    name: "Edit Student",
    key: "students/edit/:admissionNo",
    icon: <Icon fontSize="small">edit</Icon>,
    route: "students/edit/:admissionNo",
    component: <EditStudents />,
  },
  {
    type: "",
    name: "Student Profile",
    key: "students/profile",
    icon: <Icon fontSize="small">person</Icon>,
    route: "students/profile/:admissionNo",
    component: <StudentProfile />,
  },
  {
    type: "collapse",
    name: "Students List",
    key: "students",
    icon: <Icon fontSize="small">groups</Icon>,
    route: "/students",
    component: <StudentsList />,
  },
  {
    type: "collapse",
    name: "Advanced Search",
    key: "students/advancedsearch",
    icon: <Icon fontSize="small">search</Icon>,
    route: "/students/advancedsearch",
    component: <AdvancedSearch />,
  },
  {
    type: "collapse",
    name: "Search by Name or ID",
    key: "students/search",
    icon: <Icon fontSize="small">search</Icon>,
    route: "/students/search",
    component: <QuerySearch />,
  },
  {
    type: "title",
    title: "Actions",
    key: "actions",
  },
  {
    type: "collapse",
    name: "Students In / Out",
    key: "students/inout",
    icon: <Icon fontSize="small">confirmation_number</Icon>,
    route: "/students/inout",
    component: <StudentInOut />,
  },
  {
    type: "collapse",
    name: "Mess Attendance",
    key: "students/attendance",
    icon: <Icon fontSize="small">check</Icon>,
    route: "/students/attendance",
    component: <Stdatt />,
  },
  {
    type: "title",
    title: "Manage Account",
    key: "manage-account",
  },
  {
    type: "",
    name: "Sign In",
    key: "sign-in",
    icon: <Icon fontSize="small">login</Icon>,
    route: "/authentication/sign-in",
    component: <SignIn />,
  },
  {
    type: "",
    name: "Sign Up",
    key: "sign-up",
    icon: <Icon fontSize="small">assignment</Icon>,
    route: "/authentication/sign-up",
    component: <SignUp />,
  },
  {
    type: "collapse",
    name: "Reset Password",
    key: "reset-password",
    icon: <Icon fontSize="small">assignment</Icon>,
    route: "/authentication/reset-password",
    component: <ResetPassword />,
  },
];

export default routes;
